// Actions
import {
  SESSION_SET_CURRENT_CUSTOMER,
  SESSION_SET_LISTING_TYPE,
  SESSION_SET_LISTASYNCPROCESS,
  SESSION_ADD_LISTASYNCPROCESS,
  SESSION_REMOVE_LISTASYNCPROCESS,
  SESSION_CLEAN_LISTASYNCPROCESS,
  SESSION_UPDATE_LISTASYNCPROCESS,
} from '../actionTypes';

// Plugins
import {
  applyRuntimeEntitlementsToCustomer,
  areEntitlementsEqual,
  fetchCustomerRuntimeEntitlements,
} from '../../plugins/entitlements';

/**
 * Sets the current customer for Customer Panel flows.
 * Dispatches immediately with the mgnt payload so navigation is not blocked, then
 * hydrates entitlements via GET /entitlements (customer account) in background.
 * Callers that need the hydrated payload can still await this action.
 */
export const setCurrentCustomerForPanel = (customer) => async (dispatch) => {
  // Fail closed: no module is entitled until the customer account answers, so navigation
  // never renders a module based on a stale payload.
  const initialPayload = { ...customer, entitlements: {} };

  dispatch({
    type: SESSION_SET_CURRENT_CUSTOMER,
    payload: initialPayload,
  });

  const customerPayload = await applyRuntimeEntitlementsToCustomer(customer);

  if (!areEntitlementsEqual(initialPayload.entitlements, customerPayload.entitlements)) {
    dispatch({
      type: SESSION_SET_CURRENT_CUSTOMER,
      payload: customerPayload,
    });
  }

  return customerPayload;
};

/**
 * Soft-refreshes entitlements for the current session customer.
 * Used by background polling / tab focus — async, and skips Redux when unchanged.
 */
export const refreshCurrentCustomerEntitlements = () => async (dispatch, getState) => {
  const { customer } = getState().session;

  if (!customer?.api?.user) {
    return null;
  }

  const entitlements = await fetchCustomerRuntimeEntitlements(customer);

  if (areEntitlementsEqual(customer.entitlements, entitlements)) {
    return customer;
  }

  const customerPayload = {
    ...customer,
    entitlements,
  };

  dispatch({
    type: SESSION_SET_CURRENT_CUSTOMER,
    payload: customerPayload,
  });

  return customerPayload;
};

/** Clears the current customer from session when no tenant context is selected */
export const clearCurrentCustomer = () => (dispatch) => {
  dispatch({
    type: SESSION_SET_CURRENT_CUSTOMER,
    payload: null,
  });
};

/** Sets the listing type */
export const setListingType = (payload) => (dispatch) => new Promise((resolve) => {
  dispatch({
    type: SESSION_SET_LISTING_TYPE,
    payload,
  });
  resolve();
});

/** Sets the list of async process */
export const setListAsyncProcess = (payload) => (dispatch) => new Promise((resolve) => {
  dispatch({
    type: SESSION_SET_LISTASYNCPROCESS,
    payload,
  });
  resolve();
});

/** Updates the list of async process */
export const updateListAsyncProcess = (payload) => (dispatch) => new Promise((resolve) => {
  dispatch({
    type: SESSION_UPDATE_LISTASYNCPROCESS,
    payload,
  });
  resolve();
});

/** Sets the list of async process */
export const addListAsyncProcess = (payload) => (dispatch) => new Promise((resolve) => {
  dispatch({
    type: SESSION_ADD_LISTASYNCPROCESS,
    payload,
  });
  resolve();
});

/** Removes item from list of async process */
export const removeListAsyncProcess = (payload) => (dispatch) => new Promise((resolve) => {
  dispatch({
    type: SESSION_REMOVE_LISTASYNCPROCESS,
    payload,
  });
  resolve();
});

/** Sets the list of async process */
export const cleanListAsyncProcess = () => (dispatch) => new Promise((resolve) => {
  dispatch({
    type: SESSION_CLEAN_LISTASYNCPROCESS,
  });
  resolve();
});
